import { render, staticRenderFns } from "./FrameCheckQuiz.vue?vue&type=template&id=6f4d2697&scoped=true&"
import script from "./FrameCheckQuiz.vue?vue&type=script&lang=js&"
export * from "./FrameCheckQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4d2697",
  null
  
)

export default component.exports